module.exports = __webpack_public_path__ + "media/images/writer/follow_up_mailer/video_3-8a699b8fd54768efa358ece3c431cebc.png";